import React, { useState } from 'react'
import { connect } from 'react-redux'
import { IconButton } from '@material-ui/core'
import ReceiptIcon from '@material-ui/icons/Receipt'
import TicketDeDescargaPdf from '../components/TicketDeDescargaPdf'
import { descargarDetallePdf, obtenerDetalleMercaderia, saveDetallePdf } from '../actions'

function TicketDeDescarga (props) {
  const { numero } = props
  const [download, setDownload] = useState(false)

  const descargarTicket = async () => {
    const detalle = await props.obtenerDetalleMercaderia(numero)
    if (detalle !== null) {
      setDownload(true)
      props.descargarDetallePdf()
    }
  }

  const saveDetalle = () => {
    setDownload(false)
    saveDetallePdf()
  }

  return (
    <>
      <IconButton onClick={descargarTicket} style={{ outline: 'none' }}>
        <ReceiptIcon fontSize='default' color='primary' />
      </IconButton>
      <div className='hidden'>
        { props.fileDetallePdfOk && download
          ? <TicketDeDescargaPdf
            detalleLiqMercaderia={props.detalleLiqMercaderia}
            acta={props.acta}
            versionLaridae={props.versionLaridae}
            saveDetalle={saveDetalle}
          />
          : null
        }
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    acta: state.pdfDownload.acta,
    detalleLiqMercaderia: state.pdfDownload.detalleLiqMercaderia,
    fileDetallePdfOk: state.pdfDownload.fileDetallePdfOk,
    versionLaridae: state.utils.versionLaridae
  }
}

const mapActionsToProps = {
  descargarDetallePdf,
  obtenerDetalleMercaderia,
  saveDetallePdf
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(TicketDeDescarga)
